import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
/**
 * Generated class for the FormatPricePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'hasReported',
})
export class HasReportedPipe implements PipeTransform {
  /**
   * Takes a job and displays the compensation in a human readable format Based
   * on the following fields:

   */

  hasReported = function (userIds, userId: string) {
    if (_.size(userIds)) {
      return _.includes(userIds, userId);
    } else {
      return false;
    }
  };

  transform(value: any, ...args) {
    return this.hasReported(value, args[0]);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/has-reported/has-reported.ts